import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LabelText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', htmlFor, testId = TEST_ID } = props;

    return (
        <label
            className={`${className} ${styles.labelText}`}
            data-testid={testId}
            htmlFor={htmlFor}>
            {children}
        </label>
    );
};

export default LabelText;
